import ApiService from "@/utils/request"

export const CompServe = {
  async downloadFile(id) {
    const res = await ApiService.query(
      "common/files/download/",
      { id },
      { getResponse: true }
    )
    // 读取成功时没有 success
    if (res.success !== false) {
      const { response } = res
      const disposition = response.headers.get("content-disposition")
      const blob = await response.blob()
      return {
        success: true,
        data: {
          uuid: id,
          file: blob,
          name: decodeURIComponent(disposition.split("=")[1])
        }
      }
    }
    return res
  },
  uploadFile(file) {
    return ApiService.formPost(`common/files/upload/`, {
      file: file,
      name: file.name
    })
    //return Promise.reject()
  },
  uploadBase64(params) {
    return ApiService.post(`common/upload/base64/`, params)
  },
  async downloadScaleFile(id) {
    const res = await ApiService.query(
      "common/scaleImages/download/",
      { id },
      { getResponse: true }
    )
    // 读取成功时没有 success
    if (res.success !== false) {
      const { response } = res
      const disposition = response.headers.get("content-disposition")
      const blob = await response.blob()
      return {
        success: true,
        data: {
          uuid: id,
          file: blob,
          name: decodeURIComponent(disposition.split("=")[1])
        }
      }
    }
    return res
  }
}
